import { render, staticRenderFns } from "./FullRestFields.vue?vue&type=template&id=4019da5d"
import script from "./FullRestFields.vue?vue&type=script&lang=js"
export * from "./FullRestFields.vue?vue&type=script&lang=js"
import style0 from "./FullRestFields.vue?vue&type=style&index=0&id=4019da5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports